import axiosInstance from "../libs/axiosInstance";

// Start a new quiz session
export const startQuizSession = async (quizId) => {
    const response = await axiosInstance.post('/quiz-session/', {
        quiz: quizId
    });
    return response.data;
};

export const getUserQuizSession = async () => {
    const response = await axiosInstance.get('/quiz-session/');
    return response.data;
};

export const getAllUserQuizSessions = async () => {
    const response = await axiosInstance.get('/quiz-session/admin/sessions/');
    return response.data;
}

export const fetchQuizSessions = async (quizId) => {
    const response = await axiosInstance.get(`/quiz-session/lecturer/quiz/${quizId}/sessions/`);
    return response.data;
};

export const validateQuizSession = async (sessionId) => {
    const response = await axiosInstance.get(`/quiz-session/${sessionId}/validate/`);
    return response.data;
}
